import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "../styles/loginPage.js";
import image from "../assets/img/signIn-bg.webp";
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from "../components/AlertDialog";
import { FirebaseContext, api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import SignInForm from "components/Auth/SignIn.js";
import SignUpForm from "components/Auth/SignUpForm.js";
// import AuthFooter from "components/Footer/AuthFooter.js";
import Availability from "components/Availability.js";
import HomeFooter from "components/Footer/HomeFooter.js";

const useStyles = makeStyles(styles);

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const initShowSignUp = searchParams.get("signup");
  const { RecaptchaVerifier } = useContext(FirebaseContext);
  const { t } = useTranslation();
  const { clearLoginError } = api;
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [capatchaReady, setCapatchaReady] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSignUp, setShowSignUp] = useState(
    initShowSignUp === "true" ? true : false
  );

  const [data, setData] = React.useState({
    email: "",
    confirmpassword: "",
    country: "",
    contact: "",
    mobile: "",
    password: "",
    otp: "",
    verificationId: null,
    firstName: "",
    lastName: "",
    selectedcountry: null,
    usertype: "customer",
    referralId: "",
    entryType: null,
  });

  const [otpCalled, setOtpCalled] = useState();

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const classes = useStyles();

  useEffect(() => {
    if (!window.recaptchaVerifier) {
      setCapatchaReady(true);
    }
    if (auth.profile) {
      if (auth.profile.uid) {
        let role = auth.profile.usertype;
        if (role === "admin" || role === "fleetadmin") {
          // navigate("/dashboard");
        } else if (role === "driver") {
          navigate("/bookings");
        } else {
          navigate("/");
        }
      }
    }
    if (
      auth.error &&
      auth.error.flag &&
      auth.error.msg.message !== t("not_logged_in")
    ) {
      if (auth.error.msg.message === t("require_approval")) {
        setCommonAlert({ open: true, msg: t("require_approval") });
      } else if (
        auth.error.msg.message ===
        "Firebase: Error (auth/invalid-verification-code)."
      ) {
        setCommonAlert({ open: true, msg: t("login_error") });
        setIsLoading(false);
      } else {
        if (data.contact && (data.contact === "" || !!data.contact)) {
          setCommonAlert({ open: true, msg: t("login_error") });
          setIsLoading(false);
        }
      }
    }
    if (auth.verificationId && otpCalled) {
      setOtpCalled(false);
      setData({ ...data, verificationId: auth.verificationId });
    }
  }, [
    auth.profile,
    auth.error,
    auth.verificationId,
    navigate,
    data,
    data.email,
    data.contact,
    capatchaReady,
    RecaptchaVerifier,
    t,
    setData,
    otpCalled,
    setOtpCalled,
  ]);

  // const handleGoogleLogin = (credentialResponse) => {
  //   if (credentialResponse && credentialResponse.credential) {
  //     dispatch(googleLogin(credentialResponse.credential, null));
  //   } else {
  //     setCommonAlert({ open: true, msg: t("login_error") });
  //     setIsLoading(false);
  //   }
  // };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      setData({ ...data, email: "", pass: "" });
      dispatch(clearLoginError());
    }
  };

  useEffect(() => {
    setShowSignUp(initShowSignUp === "true" ? true : false);
  }, [initShowSignUp]);

  return (
    <div>
      <Header
        color="transparent"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 10,
          color: "dark",
        }}
      />

      <div
        className={classes.loginContainer}
        style={{
          position: "relative",
          backgroundImage: `linear-gradient(270.83deg, rgba(0, 0, 0, 0) 10.94%, rgba(0, 0, 0, 0.7) 50.11%), url(${image})`,
          backgroundSize: "cover, cover",
          backgroundPosition: "center center, center center",
          backgroundRepeat: "no-repeat, no-repeat",
          minHeight: "100vh",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // alignItems: "center",
          padding: "20px",
          paddingTop: "100px",
        }}
      >
        {showSignUp ? (
          <SignUpForm
            setShowSignUp={setShowSignUp}
            switchToSignIn={() => setShowSignUp(false)}
          />
        ) : (
          <SignInForm switchToSignUp={() => setShowSignUp(true)} />
        )}
      </div>
      {/* <Footer whiteFont /> */}
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>

      {/* <AuthFooter /> */}
      <Availability />
      <HomeFooter />
    </div>
  );
}
